<template>
  <div class="notification-message__wrapper">
    <div class="notification-message__content text-primary-navigation">
      <a-render-html
        :container-tag="$options.consts.HTML_TAG.PARAGRAPH"
        :html="processHtml(notification.Message)"
      />
    </div>
    <p class="notification-message__date text-medium">{{ notificationDate }}</p>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
import { propValidator, PROP_TYPES } from '@/utils/validators'
import ARenderHtml from 'shared/ARenderHtml'
import { processHtml } from '@/utils/helpers/processHtml'
import { HTML_TAG } from '@/utils/helpers/processHtml/enums'

export default {
  name: 'AnnouncementNotification',
  mixins: [mixins.urlGenerators],
  components: { ARenderHtml },
  props: {
    notification: propValidator([PROP_TYPES.OBJECT], true)
  },
  consts: { HTML_TAG },
  computed: {
    notificationDate() {
      return this.$helper.formatDate.toDate(this.notification.CreatedOn)
    },
    notificationMessage() {
      return this.notification.Message
    }
  },
  methods: {
    processHtml
  }
}
</script>

<style lang="scss" scoped>
.notification-message__wrapper {
  display: block;
  position: relative;
  padding: 0 18px 0 14px;
  margin: 16px 0 0;

  &:not(:last-child) {
    padding-bottom: 16px;
    border-bottom: 1px solid $c--gray-dark;
  }

  &::before {
    position: absolute;
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: $c--main;
    top: 7px;
    left: 0;
  }

  .notification-message__content,
  .notification-message__date {
    display: block;
    font-weight: 400;
    text-align: left;
    color: $c--white;
  }

  .notification-message__date {
    color: rgba($c--white, 0.5);
    margin-top: 8px;
  }
}
</style>
